import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import Fallback from '../components/Fallback';
import logger from './logger';

const exportWithBoundary = (Component, fallback = Fallback) => {
  const handleError = (error, info) => {
    logger.error(error);
    logger.info(info);
  };

  return React.forwardRef((props, ref) => (
    <ErrorBoundary FallbackComponent={fallback} onError={handleError}>
      <Component {...props} ref={ref} />
    </ErrorBoundary>
  ));
};

export default exportWithBoundary;
